import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SHA256 } from 'crypto-js';
import { AuthService } from 'src/app/services/auth.service';
import { StorageService } from 'src/app/services/storage.service';
import { ToastService } from 'src/app/services/toast.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-tablet-home',
  templateUrl: './tablet-home.component.html',
  styleUrls: ['./tablet-home.component.scss'],
})
export class TabletHomeComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private toastService: ToastService,
    private storageService: StorageService,
    private router: Router
  ) {}
  environment = environment;

  ngOnInit(): void {}

  logout() {
    // First input
    let firstInput = prompt('Por favor, ingrese su email de entrenador: ');

    // Check if the user canceled the first input
    if (firstInput !== null) {
      // Second input
      let secondInput = prompt('Por favor, ingrese su contraseña:');

      // Check if the user canceled the second input
      if (secondInput !== null) {
        const password = SHA256(secondInput as string)
          .toString()
          .toUpperCase();

        // Call authService.loginTablet with both inputs and subscribe to the result
        this.authService
          .loginTablet({ email: firstInput, password })
          .subscribe({
            next: (response) => {
              this.toastService.success('Cerrando sesión con éxito.');
              this.storageService.delete('isTablet');
              this.storageService.delete('accessToken');
              this.storageService.delete('refreshToken');
              this.storageService.delete('staffUser');
              this.router.navigate(['/login-tablet']);
            },
            error: (error) => {
              if (error.status === 404) {
                this.toastService.alert(
                  'Credenciales incorrectas. Verifique su nombre de usuario y contraseña.'
                );
              } else {
                this.toastService.alert(
                  'Error al iniciar sesión. Inténtelo de nuevo.'
                );
              }
            },
          });
      } else {
        this.toastService.alert('El ingreso de la contraseña fue cancelado.');
      }
    } else {
      this.toastService.alert(
        'El ingreso del nombre de usuario fue cancelado.'
      );
    }
  }
}
